import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "inline-flex rounded-full bg-gray-100 p-0.5",
  role: "group",
  "aria-label": "Required or optional"
}
const _hoisted_2 = ["aria-pressed", "onClick"]


export default {
  __name: 'RequiredSwitch',
  props: {
  required: { type: Boolean, required: true }
},
  emits: ['update:required'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const OPTIONS = [
  { label: 'Required', value: true },
  { label: 'Optional', value: false }
]

const choose = value => {
  if (value !== props.required) emit('update:required', value)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(OPTIONS, (option) => {
      return _createElementVNode("button", {
        key: option.label,
        type: "button",
        class: _normalizeClass(["rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors", 
        __props.required === option.value
          ? 'bg-white text-gray-900 ring-1 ring-inset ring-gray-300'
          : 'text-gray-500 hover:text-gray-800'
      ]),
        "aria-pressed": __props.required === option.value,
        onClick: $event => (choose(option.value))
      }, _toDisplayString(option.label), 11, _hoisted_2)
    }), 64))
  ]))
}
}

}